export const logicalXOR = (valueOne, valueTwo) => !!(valueOne && !valueTwo || !valueOne && valueTwo);